import React from 'react';

import { LinkProps } from 'Elements/Link';

import { Container, Label, StyledLink } from '../InformationBlocks.styled';

export interface Props {
    name: string;
    mapLink: LinkProps;
}

const Campus: React.FC<Props> = props => {
    const { name, mapLink } = props;

    return (
        <Container>
            <Label>
                Campus: <strong>{name}</strong>
            </Label>
            <StyledLink {...mapLink} openInNewTab />
        </Container>
    );
};

export default Campus;
